<div class="layout-topbar">
    <div class="layout-topbar-logo-container">
        <button class="layout-menu-button layout-topbar-action" (click)="layoutService.onMenuToggle()">
            <i class="pi pi-bars"></i>
        </button>
        <a class="layout-topbar-logo" routerLink="/">
            <app-brand-logo />
        </a>
    </div>

    <div class="layout-topbar-actions">
        <div class="layout-config-menu">
            <button type="button" class="layout-topbar-action" (click)="toggleDarkMode()">
                <i
                    [ngClass]="{
                        'pi ': true,
                        'pi-moon': layoutService.isDarkTheme(),
                        'pi-sun': !layoutService.isDarkTheme(),
                    }"
                ></i>
            </button>
            <div class="relative">
                <button
                    class="layout-topbar-action layout-topbar-action-highlight"
                    pStyleClass="@next"
                    enterFromClass="hidden"
                    enterActiveClass="animate-scalein"
                    leaveToClass="hidden"
                    leaveActiveClass="animate-fadeout"
                    [hideOnOutsideClick]="true"
                >
                    <i class="pi pi-palette"></i>
                </button>
                <app-configurator />
            </div>
        </div>

        <button
            class="layout-topbar-menu-button layout-topbar-action"
            pStyleClass="@next"
            enterFromClass="hidden"
            enterActiveClass="animate-scalein"
            leaveToClass="hidden"
            leaveActiveClass="animate-fadeout"
            [hideOnOutsideClick]="true"
        >
            <i class="pi pi-ellipsis-v"></i>
        </button>

        <div class="layout-topbar-menu hidden lg:block">
            <div class="layout-topbar-menu-content">
                <button type="button" class="layout-topbar-action" (click)="calendarPopover.toggle($event)">
                    <i class="pi pi-calendar"></i>
                    <span>Calendar</span>
                </button>
                <app-ai-assist-status />
                <button type="button" class="layout-topbar-action" (click)="profilePopover.toggle($event)">
                    <i class="pi pi-user"></i>
                    <span>Profile</span>
                </button>
            </div>
        </div>
    </div>
</div>

<p-popover #calendarPopover>
    <p-datepicker [inline]="true" [(ngModel)]="calendarDate" />
</p-popover>

<p-popover #profilePopover [style]="{ width: '20rem' }">
    @if (authService.currentAdmin(); as admin) {
        <div class="flex flex-col gap-4 p-2">
            <div class="flex items-center gap-3">
                <div
                    class="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-primary-contrast font-bold"
                >
                    {{ admin.Login.slice(0, 2).toUpperCase() }}
                </div>
                <div>
                    <div class="font-semibold">{{ admin.Login }}</div>
                    <div class="text-sm text-muted-color">{{ admin.Id }}</div>
                </div>
            </div>
            <div class="border-t border-surface pt-3">
                <div class="text-sm font-medium mb-1">Access</div>
                @if (admin.Access._type === 'global') {
                    <p-tag value="Global Access" severity="success" />
                } @else {
                    <p-tag value="Realm Access" severity="info" />
                    <div class="mt-2 flex flex-col gap-1">
                        @for (realm of admin.Access.AllowedRealms; track realm) {
                            <span class="text-sm text-muted-color font-mono">{{ realm }}</span>
                        }
                    </div>
                }
            </div>
            <div class="border-t border-surface pt-3">
                <p-button
                    label="Logout"
                    icon="pi pi-sign-out"
                    severity="danger"
                    class="w-full"
                    [style]="{ width: '100%' }"
                    (onClick)="logoutDialogVisible.set(true); profilePopover.hide()"
                />
            </div>
        </div>
    }
</p-popover>

<p-dialog
    header="Confirm Logout"
    [visible]="logoutDialogVisible()"
    (visibleChange)="logoutDialogVisible.set($event)"
    [style]="{ width: '28rem' }"
    [modal]="true"
>
    <div class="flex items-center gap-3">
        <i class="pi pi-exclamation-triangle text-3xl text-red-500"></i>
        <span>Are you sure you want to logout?</span>
    </div>
    <ng-template #footer>
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" (onClick)="logoutDialogVisible.set(false)" />
            <p-button label="Logout" severity="danger" icon="pi pi-sign-out" (onClick)="logout()" />
        </div>
    </ng-template>
</p-dialog>
